import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

export function useCreate(queryParams) {
    const queryClient = useQueryClient();
    const { queryKey } = queryParams;

    return useMutation({
        mutationFn: async (data:any) => {
            const { data: response } = await authenticatedApi.post(`/${queryKey[0]}`, data);
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey });
            queryClient.invalidateQueries({ queryKey: ["serachselect_"+queryKey[0]] }); // searches (for when something is quick-added)
        },
    });
}
